import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useToasts } from 'react-toast-notifications';
import handleRequest from '../utils/handleRequest';

const UploadContext = React.createContext();

const UploadProvider = (props) => {
  const { addToast } = useToasts();

  const uploadFile = useCallback(async (data) => {
    const formData = new FormData();
    formData.append('file', data);

    const res = await handleRequest({
      method: 'post',
      url: '/upload',
      data: formData,
    });

    if (res.status === 200) {
      addToast('File uploaded successfully.', {
        appearance: 'success',
        autoDismiss: true,
      });
    } else {
      addToast('Some err', {
        appearance: 'error',
        autoDismiss: true,
      });
    }
  }, []);

  return (
    <UploadContext.Provider
      value={{
        state: {},
        actions: { uploadFile },
      }}
    >
      {props.children}
    </UploadContext.Provider>
  );
};

UploadContext.propTypes = {
  children: PropTypes.element,
};

export { UploadProvider, UploadContext };
